// extracted by mini-css-extract-plugin
export default {"ps":"cvbbmcj7i"};